import { render, staticRenderFns } from "./RequestModified.vue?vue&type=template&id=0ea19384"
import script from "./RequestModified.vue?vue&type=script&lang=js"
export * from "./RequestModified.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports